import { GridHorizontal } from '@styled-icons/boxicons-regular';
import { NavbarElement } from '@typedream/core';
import React, { useEffect } from 'react';
import { useDrag } from 'react-dnd';
import styled from 'styled-components';
import { useTPlateEditorRef } from '../../../../plate';

interface DragHandleProps {
  element: NavbarElement
  columnId?: string,
  columnItemId?: string,
  reference?: React.RefObject<HTMLElement>
}

const Grabber = styled.div`
  position: absolute;
  top: 0px;
  left: 50%;
  line-height: 1;
  transform: translateX(-50%);
  color: var(--text-light);
  cursor: grab;
  pointer-events: all;
  user-select: none;
  z-index: 1;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;
export const DropdownMenuDragHandle = React.forwardRef((props: DragHandleProps) => {
  const {
    element, reference, columnId, columnItemId,
  } = props;
  const editor = useTPlateEditorRef();
  if (
    element.type === 'navbar_dropdown_menu'
  ) {
    return <div />;
  }

  const [, dragSource, dragPreview] = useDrag(
    () => ({
      type: element.type,
      item: () => {
        editor.isDragging = true;
        if (element.type === 'navbar_dropdown_menu_column') {
          return {
            columnId,
          };
        }

        return { columnId, columnItemId };
      },
      end: () => {
        delete editor.isDragging;
      },
    }),
    [element],
  );

  useEffect(() => {
    try {
      if (reference?.current) {
        const domElement = reference.current;
        if (domElement) {
          const rect = domElement.getBoundingClientRect();
          dragPreview(domElement, {
            offsetX: rect.width / 2,
            offsetY: rect.height / 2,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, [reference]);

  return (
    <Grabber
      role="none"
      ref={dragSource}
    >
      <GridHorizontal
        size={20}
      />
    </Grabber>
  );
});

DropdownMenuDragHandle.defaultProps = {
  reference: undefined,
  columnId: undefined,
  columnItemId: undefined,
};
